import Vue from 'vue';

export default Vue.component('dynamic-input-textarea', {
  template: require('./template.html'),
  name: 'dynamic-input-textarea',
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
    'input-errors',
  ],
  data() {
    return {
      hasErrors: false,
      display: {},
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
    inputErrors(list) {
      this.hasErrors = list.find(item => item.key === this.type);
    },
  },
  methods: {
    setInitialValues() {
      this.$set(this.display, this.type, this.activeItem[this.type] || '');
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
    handleErrors() {
      if (this.value.required) {
        const value = this.display[this.type] || '';
        const input = value.replace(/\s/g, '');
        const hasError = this.value.required && input === '';
        this.$emit('set-input-error', { key: this.type, hasError, tab: this.dynamicTab });
        this.hasErrors = hasError;
      } else {
        this.hasErrors = false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/textarea/index.js